import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import LoadingDots from 'src/components/access/LoadingDots';
import useSessionStorage from 'src/hooks/useSessionStorage';

export const Route = createFileRoute('/access_/authentication')({
	component: AuthenticationPage,
});

function AuthenticationPage() {
	const navigate = useNavigate();
	const search = useSearch({ strict: false }) as { auth?: string; redirect?: string };
	const { value: authToken, updateValue } = useSessionStorage('accessAuthToken');

	useEffect(() => {
		if (!search.auth && !authToken) {
			navigate({ to: '/access/401' });
			return;
		}

		if (search.auth) {
			updateValue(search.auth);
		}

		// Redirect to specified path or default to overview
		// Use requestAnimationFrame to ensure sessionStorage is committed before overview's API calls run
		const redirectPath = search.redirect || '/access/overview';
		const id = requestAnimationFrame(() => {
			navigate({ to: redirectPath, replace: true });
		});
		return () => cancelAnimationFrame(id);
	}, [search.auth, search.redirect, authToken, updateValue, navigate]);

	return <LoadingDots />;
}
